export default __webpack_public_path__ + "static/media/slip.d09b0e88.svg";